import { useEffect, useRef } from "react";
import { useData } from "./DataContext.js";
import { getSimParam } from "./utils.js";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import ButtonGroup from "react-bootstrap/ButtonGroup";

import Title from "./Title.js";
import ArticleCard from "./ArticleCard.js";
import SessionPanel from "./SessionPanel.js";
import AmendmentList from "./AmendmentList.js";

export default function PlayArticles ()
{
    const gData = useData();

    // ARTICLE LIST
    const selectedArticleList = Object
	.entries(gData.article)
	.filter(([id, article]) => {
	    return article.simID === gData.simID
		&& (article.sessionNum === null || article.sessionNum === gData.sim[gData.simID].sessionNum)
		&& gData.article[article.firstArticleID].selected === 1 // TODO: potential sync error?
		&& article.rank >= 0;
	})
	.sort(([id1, article1], [id2, article2]) => { return article1.rank - article2.rank; })
	.map(([id, article], index) => { return (<ArticleCard key={article.articleID} articleID={article.articleID} articleNum={index}/>); });
    // TODO : compute real index when notice is not selected

    const newArticleCard = (<ArticleCard/>);

    // AMENDMENT LIST
    const amendmentListRef = useRef(null)

    let selectedState = null;
    let selectedDisplayAll = null;
    let selectedArticleID = null;
    let selectedAmendmentID = null;
    
    if (gData.amendmentState !== null)
    {
	selectedState = gData.amendmentState.state;
	selectedDisplayAll = gData.amendmentState.displayAll;
	selectedArticleID = gData.amendmentState.articleID;
	selectedAmendmentID = gData.amendmentState.amendmentID;
    }

    useEffect(() => { amendmentListRef.current.scrollIntoView({ behavior: "smooth" }); }, [gData.amendmentState]);
    

    // SESSION CARD
    const sessionNum = gData.sim[gData.simID].sessionNum;
    const sessionStep = getSimParam(gData, "sessionStep");

    let sessionHeader = "";

    if (sessionStep === "end") sessionHeader = "Fin de la session " + sessionNum;
    else sessionHeader = "Session " + sessionNum + " en cours";

    
    // RENDER
    return (
	<Container className="d-flex justify-content-center gap-5 vh-100">
	    <Col className="overflow-scroll mb-3 px-3 py-3" style={{ marginTop: 70 }}>
		<div>
		    <Title>Texte de loi</Title>
		    <div className="d-flex flex-column align-items-center gap-3">
			{selectedArticleList}
			{newArticleCard}
		    </div>
	    </div>
	    </Col>
	    <Col className="overflow-scroll mb-3 px-3 py-3" style={{ marginTop: 70 }}>
		<div className="d-flex flex-column gap-3">
		    <div>
			<Title>{sessionHeader}</Title>
			<SessionPanel/>
		    </div>
		    <div ref={amendmentListRef}>
			<Title>Amendements</Title>
			<ButtonGroup className="text-center w-100 mb-3"><AmendmentList.Buttons displayAll={true}/></ButtonGroup>
			<AmendmentList state={selectedState} displayAll={selectedDisplayAll} articleID={selectedArticleID} amendmentID={selectedAmendmentID}/>
		    </div>
		</div>
	    </Col>
	</Container>
    );
}
